import { filter, get, isNil, map } from 'lodash'

import { findNodeByValue, formatScore } from '../../common/utils'

const getNodesFromAiSuggestions = (treeData, aiSuggestions) =>
  filter(
    map(aiSuggestions, ({ id }) => findNodeByValue(treeData, id)),
    node => !isNil(node),
  )

const getSuggestedByAiTreeData = (metadata, aiSuggestions = []) =>
  isNil(get(aiSuggestions, '[0].messages'))
    ? map(
        getNodesFromAiSuggestions(metadata, aiSuggestions),
        (node, index) => ({
          ...node,
          path: `${node.namePath} (${formatScore(
            aiSuggestions[index].score,
          )}%)`,
          title: `${node.title} (${formatScore(aiSuggestions[index].score)}%)`,
        }),
      )
    : []

export default getSuggestedByAiTreeData
